// src/app/job-description-model-popup/job-description-model-popup.component.ts
//Beautification Adding Double Quotes is Good Practice

import {Component, Input, ViewChild,ElementRef,HostListener,ViewChildren,QueryList,} from "@angular/core";
import { CommonModule } from "@angular/common";
import { WidgetInput } from '../../../Common/Models/widget.model';
import {StripHtmlPipe,SafeEmbedHtmlPipe,} from "../../../Common/pipes/Angular-commonUtil.pipe";
import { TranslateModule } from "@ngx-translate/core";




@Component({
  selector: "job-description-model-popup",
  standalone: true,
  imports: [CommonModule, StripHtmlPipe, SafeEmbedHtmlPipe,TranslateModule],
  templateUrl: "./job-description-model-popup.component.html",
  styleUrls: ["./job-description-model-popup.component.scss"],
})
export class JobDescriptionModelPOPUPComponent {
  @ViewChild("modalContent") modalContent!: ElementRef;
  @ViewChild("modalStart") closeButton!: ElementRef;
  @ViewChildren("accordionItem", { read: ElementRef })
  accordionItems!: QueryList<ElementRef>;
  @ViewChild("modalContainer") modalContainer!: ElementRef;
  @ViewChildren("accordionBody", { read: ElementRef }) accordionBodies!: QueryList<ElementRef>;

  pagetype: string = "";
  jobdescpritionAndTitle: {
    JobTitle: string;
    JobDescription: string;
    Clicked:number;
  }[] = [];
  expandedJobIndex: number | null = null;
  showModal: boolean = false;
  modalReady: boolean = false;
  isSelectedJobsMode: boolean = false;
  checkedJobs: boolean[] = [];
  showAllJobsUncheckedError: boolean = false;
  private allowJoblessRefer: string = '';
  private _selectedJobsInfo: { jobTitle: string; jobDescription: string; autoReqID: string; optionalReqID: string; reqId: string }[] = [];
  @Input() set widgetData(data: WidgetInput) {
    this.allowJoblessRefer = data.tgsetting?.AllowJoblessRefer || '';
this.showAllJobsUncheckedError = false;
    if (data.popupType === 'selectedJobs' && data.selectedJobsInfo?.length) {
      this.isSelectedJobsMode = true;
      this._selectedJobsInfo = data.selectedJobsInfo;
      this.jobdescpritionAndTitle = data.selectedJobsInfo.map(job => ({
        JobTitle: job.jobTitle,
        JobDescription: job.jobDescription,
        Clicked: 0
      }));
      this.checkedJobs = this.jobdescpritionAndTitle.map(() => true);
    } else {
      this.isSelectedJobsMode = false;
      this._selectedJobsInfo = [];
      this.checkedJobs = [];
      this.jobdescpritionAndTitle = data.jobInformation || [];
    }

    this.pagetype =data.pagetype;

     const hasValidJob = this.jobdescpritionAndTitle.some(
      (item) => item?.JobTitle && item?.JobDescription?.trim()
    );

    this.showModal = hasValidJob;
    if (hasValidJob) {
      setTimeout(() => {
        this.modalReady = true;
        this.setupFocusTrap();
        if (this.closeButton) {
          this.closeButton.nativeElement.focus();
        }
      }, 0);
    }

    if (!this.isSelectedJobsMode) {
      const index = this.jobdescpritionAndTitle.findIndex(
        (item) => item.Clicked === 1
      );
      if (index !== -1 && index < this.jobdescpritionAndTitle.length) {
        setTimeout(() => {
          this.toggleAccordion(index);
        }, 500);
      }
    }
  }
  @HostListener("document:click", ["$event"])
  onDocumentClick(event: MouseEvent): void {
    if (!this.showModal || !this.modalReady) return;

    const clickedInside = this.modalContent?.nativeElement.contains(
      event.target
    );
    if (!clickedInside) {
      this.closeModal();
    }
  }

  @HostListener("document:keydown.escape", ["$event"])
  onEscapeKey(event: KeyboardEvent): void {
    this.closeModal();
  }
  toggleAccordion(index: number): void {
    const wasExpanded = this.expandedJobIndex === index;
    this.expandedJobIndex = wasExpanded ? null : index;
    setTimeout(() => {
      if (!wasExpanded) {
        const modalEl = this.modalContent?.nativeElement;
        const bodyEl = this.accordionBodies?.get(index)?.nativeElement;
        if (!bodyEl) {
          console.warn("Accordion body not found at index", index);
          return;
        }
        const modalRect = modalEl.getBoundingClientRect();
        const bodyRect = bodyEl.getBoundingClientRect();
        const offset = bodyRect.top - modalRect.top;
        if (modalEl && bodyEl) {
          const targetScrollTop = modalEl.scrollTop + offset - 20;
          this.scrollToFast(modalEl, targetScrollTop, 200); // 200ms = fast and smooth
        }
        setTimeout(() => {
          const descEl = document.getElementById(`jobDesc-${index}`) as HTMLElement | null;
          if (descEl) {
            descEl.setAttribute('tabindex', '0');
            descEl.focus({ preventScroll: true });
          }
          this.setupFocusTrap();
        }, 350);
      } else {
        setTimeout(() => {
          const descEl = document.getElementById(`jobDesc-${index}`) as HTMLElement | null;
          if (descEl) {
            descEl.setAttribute('tabindex', '-1');
          }
          this.setupFocusTrap();
          const headerEl = document.getElementById(`accordion-header-${index}`) as HTMLElement | null;
          if (headerEl) {
            headerEl.setAttribute('tabindex', '0');
            setTimeout(() => {
              headerEl.focus({ preventScroll: true });
            }, 50);
          }
        }, 100);
      }
    }, 350);
  }
  scrollToFast(
    container: HTMLElement,
    targetTop: number,
    duration: number = 300
  ) {
    const start = container.scrollTop;
    const change = targetTop - start;
    const startTime = performance.now();

    const animateScroll = (currentTime: number) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      container.scrollTop = start + change * progress;

      if (elapsed < duration) {
        requestAnimationFrame(animateScroll);
      }
    };

    requestAnimationFrame(animateScroll);
  }

  jobdescriptionhandleKeydown(event: KeyboardEvent, index: number): void {
    this.toggleAccordion(index);
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
    }
  }

  onCheckboxKeydown(event: KeyboardEvent, index: number): void {
    event.stopPropagation();
    if (event.key === 'Enter') {
      event.preventDefault();
      this.checkedJobs[index] = !this.checkedJobs[index];
    }
  }
  private setupFocusTrap(): void {
    if (!this.modalContent) return;
    if (this.modalContent.nativeElement._trap) {
      this.modalContent.nativeElement.removeEventListener("keydown", this.modalContent.nativeElement._trap);
    }
    const focusable = this.modalContent.nativeElement.querySelectorAll(
      'button:not([hidden]):not([disabled]), [href]:not([hidden]):not([disabled]), input:not([hidden]):not([disabled]), select:not([hidden]):not([disabled]), textarea:not([hidden]):not([disabled]), [tabindex]:not([tabindex="-1"]):not([hidden]):not([disabled])'
    ) as NodeListOf<HTMLElement>;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const trap = (e: KeyboardEvent) => {
      if (e.key !== "Tab" || !this.showModal || !this.modalReady) return;
      const activeElement = document.activeElement as HTMLElement;
      if (!this.modalContent.nativeElement.contains(activeElement)) {
        e.preventDefault();
        first.focus();
        return;
      }
      if (e.shiftKey && activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };
    this.modalContent.nativeElement.addEventListener("keydown", trap);
    this.modalContent.nativeElement._trap = trap;
  }

  closeModal(): void {
    this.showModal = false;
    this.modalReady = false;
    if (this.modalContent?.nativeElement._trap) {
      this.modalContent.nativeElement.removeEventListener("keydown", this.modalContent.nativeElement._trap);
      delete this.modalContent.nativeElement._trap;
    }
    const lastIndex = (window as any).lastFocusedJobIndex;
    if (lastIndex !== undefined) {
      setTimeout(() => {
        const jobTitleEl = document.getElementById(`jobTitle ${lastIndex}`);
        if (jobTitleEl) {
          jobTitleEl.setAttribute("tabindex", "0"); // ensure tabbable
          jobTitleEl.focus();
        }
      }, 200);
    }
  }
  onCheckboxChange(index: number, checked: boolean): void {
  this.checkedJobs[index] = checked;
  this.showAllJobsUncheckedError = false;
}

  onSave(): void {
    const allUnchecked = this.checkedJobs.every(c => !c);
if (this.allowJoblessRefer?.toLowerCase() === 'no' && allUnchecked) {
  this.showAllJobsUncheckedError = true;
  return;
}
this.showAllJobsUncheckedError = false;
    const checkedItems = this._selectedJobsInfo.filter((_, i) => this.checkedJobs[i]);
    const saveCallback = (window as any).onViewSelectedJobsSave;
    if (typeof saveCallback === 'function') {
      saveCallback(checkedItems);
    }
    this.closeModal();
  }
}
